import React, { useState } from 'react'
import { Row, Col, Card } from 'antd';
import { CardLogo, Chip, CreditCardBG, profile_banner } from '../utils/ImagePath';
import { FaEye, FaEyeSlash, FaHotel, FaUmbrellaBeach } from 'react-icons/fa';

const MyWallet = () => {

    let getUser = JSON.parse(localStorage.getItem('user'));
    const [isCvvVisible, setIsCvvVisible] = useState(false);

    const toggleCvvVisibility = () => {
        setIsCvvVisible(!isCvvVisible);
    };

    return (
        <>

            <section className='Edit-Profile create-profile mb-5'>
                <div className='bg-primary position-relative' style={{ height: "160px", marginBottom: "-60px" }}>
                    <img loading="lazy" src={profile_banner} alt='#' className='w-100 position-absolute' height={160} style={{ objectFit: "cover" }} />
                    <div className='w-100' style={{ background: "radial-gradient(transparent, #214a93)", height: "160px", position: "absolute" }}></div>
                    <div className='container'>
                        <Row gutter={16}>
                            <Col md={12}>
                                <h2 className='text-white pt-4'>My Wallet</h2>
                            </Col>
                            <Col md={12}></Col>
                        </Row>
                    </div>
                </div>

                <div className='container mb-5'>
                    <Row gutter={20}>
                        <Col md={6}></Col>

                        <Col md={12} xs={24} className='mt-md-0 mt-3'>
                            <div className="Reward-Point-Card img_card">
                                <img src={CreditCardBG} alt='CreditCard Background' className='credit_back' />
                                <div className="top">
                                    <h2>{getUser?.firstName} {getUser?.lastName}</h2>
                                    <img loading="lazy" src={CardLogo} alt='SuperbWorldTrip' className='brand-logo' width={'100%'} />
                                </div>

                                <div className="infos">
                                    <section className="card-middle">
                                        <div className='card-number'>
                                            <p>Card Number</p>
                                            <h2 className='d-flex align-items-center'>
                                                {getUser?.card_number
                                                    ? getUser?.card_number?.toString().replace(/(\d{4})(?=\d)/g, "$1 ")
                                                    : ""}
                                            </h2>
                                        </div>
                                        <img src={Chip} alt='chip' className='' height={49} width={60} />
                                    </section>

                                    <div className='card-number'>
                                        <p>Earned Reward Points</p>
                                        <h2 className='d-flex align-items-center'>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="#ffffff" width="20px" height="20px" viewBox="0 0 24 24" className='me-1'>
                                                <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                                <g id="SVGRepo_iconCarrier">
                                                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z" />
                                                </g>
                                            </svg>
                                             {getUser?.reward_point}
                                        </h2>
                                    </div>

                                    <div className="bottom align-items-end">
                                        <aside className="infos--bottom">
                                            <section>
                                                <p>Expiry date</p>
                                                <h3>02/25</h3>
                                            </section>
                                            <section>
                                                <p>CVV</p>
                                                <h3 className='d-flex'>
                                                    {isCvvVisible ? <>{getUser?.cvv}</> : "•••"}
                                                    <div onClick={toggleCvvVisibility} style={{ marginLeft: "10px" }}>
                                                        {isCvvVisible ? <FaEyeSlash /> : <FaEye />}
                                                    </div>
                                                </h3>
                                            </section>
                                        </aside>
                                        <aside>
                                            <section className='bottom_icons'>

                                                <FaHotel />
                                                <FaUmbrellaBeach />

                                            </section>
                                        </aside>
                                    </div>
                                </div>
                            </div>
                        </Col>

                    </Row>
                </div>

                <div className='container'>
                    <Row gutter={20}>
                        <Col md={24}>
                            <Card className='cashback-TC'>
                                <h2 className='mb-3'>100% Cash back Offer on Flights</h2>
                                <h3 className='mb-2'>Offer Overview</h3>
                                <p className=''>We are excited to introduce our 100% Cashback Offer for all flight bookings made through
                                    SuperbWorldTrip.com. By booking a flight, you will receive an equivalent amount in credits that can be
                                    used for discounts on hotel bookings and tour packages. This cash back will be credited to the user's
                                    wallet in the superbworldtrip.com portal as "Coins" (1 Coin = ₹1), which can be redeemed on eligible services.</p>
                                <hr className='my-3' />
                                <h3 className='mb-2 mt-2'>Offer Details</h3>
                                <ul className=''>
                                    <li><b>Offer Title:</b> 100% Cash back Offer on Flights</li>
                                    <li><b>Eligibility:</b> This offer is valid for users who book a flight via our portal.</li>
                                    <li><b>Offer Value:</b> When you book a flight of ₹5000 or more, you will receive the equivalent amount in credits (Coins) in your portal wallet.
                                        <ul>
                                            <li>For example, a ₹5000 flight booking earns you ₹5000 worth of credits in your wallet.</li>
                                            <li>1 Coin = 1 Rs.</li>
                                        </ul>
                                    </li>
                                    <li><b>Validity of Credits:</b> The cash back credits will be valid for Two years from the date of flight booking.</li>
                                    <li><b>Redemption of Credits:</b>
                                        <ul>
                                            <li>Credits can be used for booking hotels or tour packages available through our portal.</li>
                                            <li>You can use up to 12% of on hotel and  5% on tour packages in a single transaction.</li>
                                            <li><b>Example:</b> If you have ₹10000 in credits, you can redeem up to ₹1200 in a single transaction for hotel booking and Rs. 500 for Tour packages.</li>
                                        </ul>
                                    </li>
                                </ul>
                                <hr className='my-3' />
                                <h3 className='mb-2 mt-2'>How to Avail the Offer</h3>
                                <ol>
                                    <li><b>Book a Flight:</b>
                                        <ol>
                                            <li>Select and purchase a flight worth ₹5000 or more from our flight booking portal in a single transaction.</li>
                                            <li>The equivalent amount (in Coins) will be credited to your wallet after the successful payment of the flight booking.</li>
                                        </ol>
                                    </li>
                                    <li><b>Credits Added to Wallet:</b>
                                        <ol>
                                            <li>Once your flight booking is confirmed, the equivalent amount in Coins will be added to your wallet.</li>
                                            <li>You will receive a notification confirming the addition of credits.</li>
                                        </ol>
                                    </li>
                                    <li><b>Use Your Credits:</b>
                                        <ol>
                                            <li>Visit our hotel and tour package booking section and use your wallet credits for a discount on eligible services.</li>
                                            <li>You can use up to 12% of on hotel and  5% on tour packages in a single transaction.</li>
                                        </ol>
                                    </li>
                                    <li><b>Validity of Offer:</b>
                                        <ol>
                                            <li>The credits earned from the cash back offer must be used within Two years from the date of flight booking. </li>
                                            <li>Any unused credits will expire after Two years.</li>
                                        </ol>
                                    </li>
                                </ol>
                                <hr className='my-3' />
                                <h3 className='mb-2 mt-2'>Terms and Conditions</h3>
                                <ol>
                                    <li><b>Eligibility:</b>
                                        <ol>
                                            <li>Only registered users who book flights worth ₹5000 or more in one transaction through our portal are eligible for this cash back offer.</li>
                                        </ol>
                                    </li>
                                    <li><b>Validity Period:</b>
                                        <ol>
                                            <li>The cash back credits will expire Two years from the date of the flight booking.</li>
                                            <li>Any unused credits after the validity period will automatically lapse.</li>
                                        </ol>
                                    </li>
                                    <li><b>Non-Transferable:</b>
                                        <ol>
                                            <li>The credits earned cannot be transferred to another user or withdrawn as cash.</li>
                                        </ol>
                                    </li>
                                    <li><b>Minimum Booking:</b>
                                        <ol>
                                            <li>A flight booking of ₹5000 or more is required to earn credits. For flights priced below ₹5000, this offer does not apply.</li>
                                        </ol>
                                    </li>
                                    <li><b>Redemption of Credits:</b>
                                        <ol>
                                            <li>Credits can be used only for hotel bookings and tour packages available on our platform.</li>
                                            <li>You can use up to 12% of on hotel and  5% on tour packages in a single transaction.</li>
                                            <li>Unused credits will remain in your wallet and can be used for future bookings, subject to the two year validity.</li>
                                        </ol>
                                    </li>
                                    <li><b>Refunds and Cancellations:</b>
                                        <ol>
                                            <li>If a flight booking is canceled or refunded, the cashback credits will be revoked.</li>
                                            <li>If a hotel or tour package booking is canceled after using credits, the applicable amount in credits may be deducted from your wallet.</li>
                                        </ol>
                                    </li>
                                    <li><b>Offer Limitations:</b>
                                        <ol>
                                            <li>This offer cannot be combined with any other ongoing promotions, discounts, or cashback offers.</li>
                                            <li>The cashback offer is applicable only on the flight booking value and not on taxes, service charges, or any additional fees.</li>
                                        </ol>
                                    </li>
                                    <li><b>Changes to Offer:</b>
                                        <ol>
                                            <li>We reserve the right to modify, extend, or cancel this offer at any time without prior notice.</li>
                                            <li>Any changes made will be updated on our portal, and users will be notified accordingly.</li>
                                        </ol>
                                    </li>
                                    <li><b>Fraudulent Activity:</b>
                                        <ol>
                                            <li>Any attempt to abuse or manipulate the system to gain unfair benefits will lead to the cancellation of the credits and the account being flagged or suspended.</li>
                                        </ol>
                                    </li>
                                </ol>
                                <ul>
                                    <li>Limitation of Liability:
                                        <ol>
                                            <li>The company is not responsible for any issues arising from technical failures, network disruptions, or unauthorized use of the cashback credits.</li>
                                        </ol>
                                    </li>
                                </ul>
                                <hr className='my-3' />
                                <h3 className='mb-2 mt-2'>Customer Support</h3>
                                <p>For any queries or assistance related to the offer, feel free to contact our support team via:</p>
                                <ul>
                                    <li><b>Email:</b> support@superbworldtrip.com</li>
                                    <li><b>Phone:</b> +91-9312241999</li>
                                </ul>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </section>


        </>
    )
}

export default MyWallet
